<script setup lang="ts">
import {onMounted, onUnmounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import SidebarComponent from "@/components/SidebarComponent.vue";
import FooterImpressum from "@/components/FooterImpressum.vue";

const route = useRoute();

watch(
    () => route.meta.title,
    (title) => {
      document.title = title as string || "Dachdecke Firmenname";
    }
);

const isMobile = ref(window.innerWidth <= 1600);

const handleResize = () => {
  isMobile.value = window.innerWidth <= 1600;
};

onMounted(() => window.addEventListener("resize", handleResize));
onUnmounted(() => window.removeEventListener("resize", handleResize));

</script>

<template>
  <div class="app">
    <SidebarComponent/>
    <RouterView/>
    <FooterImpressum/>
  </div>
</template>
